import {Injectable} from '@angular/core';
import { TypesService } from './types.service';
import * as _ from 'lodash';


@Injectable({ providedIn: 'root' })
export class FeatureSwitchService {

  constructor(private typesService: TypesService) {}

  /**
   * For a given feature name, this function will retrieve the current
   * configuration and return it. If the feature does not exist within
   * @param featureName {String} The name of the feature
   * @returns {Promise<FeatureConfiguration>} An object containing the
   * feature's configuration
   */
  async retrieveSwitchingOptions(featureName) {
    try {
      // always get a fresh list of feature updates, just incase something has been switched on/off
      const featureList = await this.typesService.getTypesList('feature-switches');

      // locate the specific feature
      const featureItem = _.find(featureList, (fs) => fs.id === featureName);

      // Check if the feature item exists; if not, enable it by default
      if (!featureItem) {
        return { enabled: true };
      }

      // the ext sub-document is the feature configuration
      return featureItem.ext;
    } catch (e) {
      // always send out a document that expressly has the feature turned off
      return {
        enabled: false,
      };
    }
  }

  /**
   * For a given feature name, this function will simply determine if
   * the requested feature has been enabled
   * @param featureName {String} The name of the feature
   * @returns {Promise<Boolean>} true if the feature is enabled
   */
  async isFeatureEnabled(featureName) {
    return (await this.retrieveSwitchingOptions(featureName)).enabled;
  }

}
